import AgeGroupLabel from './AgeGroupLabel';
import { Form, Table } from './';

import React from 'react';
//import PropTypes from 'prop-types';
import { get, without } from 'lodash';

const GroupsPicker = ({ name, value: values, options, onChange }) => {
  values = values.map(JSON.stringify);

  const rows = options.map(option => {
    const value = JSON.stringify(option.primaryKey);
    return {
      ...option,
      key: option.id,
      disabled: option.disabled,
      checked: values.includes(value),
      value,
    };
  });

  const onCheckboxChange = (event, { name: value, checked, ...rest }) => {
    values = checked ? [...values, value] : without(values, value);
    onChange(event, { name, value: values.map(JSON.parse), ...rest });
  };

  return (
    <Table fixed singleLine compact="very">
      <Table.Header>
        <Table.Row>
          <Table.HeaderCell width={1} />
          <Table.HeaderCell>Age group</Table.HeaderCell>
          <Table.HeaderCell>Bodyweight category</Table.HeaderCell>
          <Table.HeaderCell>Group</Table.HeaderCell>
          <Table.HeaderCell>Entries</Table.HeaderCell>
          <Table.HeaderCell>Session</Table.HeaderCell>
        </Table.Row>
      </Table.Header>
      <Table.Body>
        {rows.map(row => (
          <Table.Row key={row.key} disabled={row.disabled}>
            <Table.Cell>
              <Form.Checkbox
                name={row.value}
                checked={row.checked}
                onChange={onCheckboxChange}
              />
            </Table.Cell>
            <Table.Cell>
              <AgeGroupLabel
                //basic={row.disabled}
                ageGroup={row.contest.ageGroup}
              />
            </Table.Cell>
            <Table.Cell>{row.contest.bodyweightCategory.title}</Table.Cell>
            <Table.Cell>{row.letter}</Table.Cell>
            <Table.Cell>{row.entries.length}</Table.Cell>
            <Table.Cell>{get(row.session, 'number', '')}</Table.Cell>
          </Table.Row>
        ))}
      </Table.Body>
    </Table>
  );
};

/*
GroupsPicker.propTypes = {
  meta: PropTypes.shape({
    groups: PropTypes.array.isRequired,
  }).isRequired,
};
*/

export default GroupsPicker;



// WEBPACK FOOTER //
// ./src/components/GroupsPicker.js